import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LockedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Locked",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.68 11.7h-1.07v-1.07c0-4.76-3.86-8.62-8.62-8.62s-8.62 3.85-8.62 8.61v1.07H6.32c-2.08 0-3.77 1.69-3.77 3.77v10.76c0 2.08 1.69 3.77 3.77 3.77h19.37c2.08 0 3.77-1.69 3.77-3.77V15.46c0-2.08-1.69-3.77-3.77-3.77Zm-6.46 7.56c0 1.19-.96 2.15-2.15 2.15v3.22a1.071 1.071 0 0 1-2.14 0v-3.24c-1.19 0-2.16-.96-2.16-2.16s.96-2.16 2.16-2.16h2.15c1.19.02 2.14.98 2.15 2.17Zm-8.61-8.63c0-2.97 2.41-5.39 5.39-5.39s5.39 2.41 5.39 5.39v1.07H10.62v-1.07Z"
    })
  }));
};